/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mealy_Sad_Goldfish_SoarInputs */

const fr_mealy_sad_goldfish_soar = /** @type {(inputs: Mealy_Sad_Goldfish_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

/**

* @param {Mealy_Sad_Goldfish_SoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mealy_sad_goldfish_soar = /** @type {((inputs?: Mealy_Sad_Goldfish_SoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mealy_Sad_Goldfish_SoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mealy_sad_goldfish_soar(inputs)
});